import "./theme.css";

import { provideMapGlobal } from "@ptx-autonomous/libs/maplibre";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import { Amplify } from "aws-amplify";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import App from "./App.vue";
import router from "./router";
import awsExports from "./aws-exports";
import { provideSettings } from "@/composables/settings";

// Configure AWS Amplify
Amplify.configure(awsExports);

// Create Vue Query client
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 2,
			staleTime: 5 * 60 * 1000, // 5 minutes
		},
	},
});

const app = createApp(App);

app.use(router);
app.use(VueQueryPlugin, { queryClient });

app.use(
	createI18n({
		locale: "en",
	}),
);

provideMapGlobal(app);

// Provide settings
provideSettings(app);

app.mount("#app");
